<bzg-modal-header>
    <span class="bz-modal__title">{{'RPA_BOTS.RETRY_QUEUEITEM_TITLE' | translate }}</span>
    <bzg-button-icon [icon]="'icon-close'" [bzgModalClose]="{trigger: 'close'}">
    </bzg-button-icon>
</bzg-modal-header>
<bzg-modal-content>
    <form [formGroup]="form">
        <h4 class="bz-form-label ng-star-inserted bz-space-inset-xs">
            {{'RPA_BOTS.QUEUE_NAME' | translate }}:
        </h4>
        <p>
            {{initialData.QueueDefinition.Name}}
        </p>
        <h4 class="bz-form-label ng-star-inserted bz-space-inset-xs">
            {{'RPA_BOTS.SPECIFIC_DATA' | translate }}:
        </h4>
        <ngx-json-viewer class="bz-json-viewer" *ngIf="specificData" [json]="specificData" [expanded]="true"></ngx-json-viewer>
        <p *ngIf="!specificData">
            {{'RPA_BOTS.NO_SPECIFIC_DATA' | translate }}.
        </p>
        <h4 class="bz-form-label ng-star-inserted bz-space-inset-xs">
            {{'RPA_BOTS.DEADLINE' | translate }}:
        </h4>
        <p>
            {{initialData.DueDate}}
        </p>
        <h4 class="bz-form-label ng-star-inserted bz-space-inset-xs">
            {{'RPA_BOTS.POSTPONE' | translate }}:
        </h4>
        <p>
            {{initialData.DeferDate}}
        </p>
        <h4 class="bz-form-label ng-star-inserted bz-space-inset-xs">
            {{'RPA_BOTS.REFERENCE' | translate }}:
        </h4>
        <p>
            {{initialData.Reference}}
        </p>
    </form>
</bzg-modal-content>
<bzg-modal-footer>
    <bzg-button-secondary class="bz-space--inline-m" [bzgModalClose]="{trigger: 'close'}">
        {{'RPA_BOTS.NO_RETRY' | translate }}</bzg-button-secondary>
    <bzg-button-primary [disabled]="form.invalid" (click)="retryQueueitem(initialData)">{{'RPA_BOTS.RETRY_QUEUEITEM' | translate}}
    </bzg-button-primary>
</bzg-modal-footer>